import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const headerMiniCartSX = (openQuickCartPanel = false, theme: Theme): SxProps => ({
	padding: '10px',
	borderRadius: '3px',
	minWidth: '50px',
	justifyContent: 'center',
	cursor: 'pointer',
	backgroundColor: openQuickCartPanel ? 'grey.50' : 'background.paper',
	svg: {
		color: openQuickCartPanel ? 'primary.main' : 'grey.500',
	},
	'&:hover': {
		backgroundColor: 'grey.50',
		svg: {
			color: 'primary.main',
		},
	},
	flexDirection: 'column',
	gap: '2px',
	height: '44px',
	[theme.breakpoints.down('md')]: {
		padding: '10px 5px',
	},
});

export const headerMiniCartIconLabelSX: SxProps = {
	color: 'grey.500',
	textAlign: 'center',
};
